<script setup>
import {onMounted, ref, reactive} from "vue";
import {storeDelete, storeList} from "@/api/post/post.js";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTCheckPanel from "@/components/YTCheckedPanel/index.vue";
import {editStoreTags} from "@/api/storeTag/storeTag.js";
import YTTagGroup from "@/components/YTTagGroup/index.vue";
import {tagsScenarioList} from "@/api/tag/tag.js";

/*初次加载*/
onMounted(async () => {
  await handleGetTagsList()
  await handleSearch()
})

/*权限相关*/

/*搜索功能*/
// 表单数据
const formData = reactive({
  name: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await storeList(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    tableData.value.forEach(item => {
      item.operatingTime = `${item.operatingStart} - ${item.operatingEnd}`
      item.showAddress = `${item.storeAddress.province}${item.storeAddress.city}${item.storeAddress.district}${item.storeAddress.addressDetail}`
      console.log("item", item)
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.name = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const panelLoading = ref(false)
const headers = ref([
  { title: '门店名', key: 'name', minWidth: "120px", maxWidth: "200px", nowrap: true },
  { title: 'English', key: 'nameEn', minWidth: "120px", maxWidth: "200px", nowrap: true },
  { title: '类型', key: 'storeType', minWidth: "120px", maxWidth: "200px", nowrap: true },
  { title: '联系地址', key: 'showAddress', minWidth: "150px", maxWidth: "350px", nowrap: true },
  { title: '联系电话', key: 'phone', maxWidth: "120xp", nowrap: true },
  { title: '营业时间数', key: 'operatingHoursChineseAndEnglish', minWidth: "150px", maxWidth: "230px", nowrap: true },
  { title: '标签', key: 'tagList', minWidth: "150px", nowrap: true },
  { title: '合作门店', key: 'isSelfOperated', minWidth: "120px", nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 展示的详情信息
const detailInfo = ref()
// 获取详情信息
const getDetail = (info) => {
  detailInfo.value = info
  router.push({path: "/addPost", query: {storeId: detailInfo.value.storeId}})
}

// 标签缓存信息
const cacheItem = ref()
// 标签多选框打开状态
const openTags = ref(false)
// 标签数据
const listTags = ref([])
// 获取标签列表
const handleGetTagsList = async () =>  {
  try {
    const param = ref({
      page: tagsPage.value,
      pageSize: 10
    })
    panelLoading.value = true
    const res = await tagsScenarioList(param.value, {usageScenario: "STORE"})
    listTags.value = []
    res.list.forEach((item) => {
      const param = {
        name: item.tagName,
        value: item.tagId
      }
      listTags.value.push(param)
    })
    tagsTotal.value = parseInt(res.total)
    panelLoading.value = false
  } catch (e) {
    console.log(e)
    panelLoading.value = false
  }
}
// 设置标签，打开选择对话框
const setTags = (item) => {
  cacheItem.value = item
  openTags.value = true
}
// 确认选择标签
const handlePanelTagsConfirm = async (item) => {
  const param = {
    storeId: cacheItem.value.storeId,
    tagIdList: item
  }
  try {
    await editStoreTags(param)
    await handleSearch()
    ElMessage.success("修改标签成功")
  } catch (e) {
    console.log(e)
  }
  openTags.value = false
}
// 取消选择标签
const handlePanelTagsClose = () => {
  cacheItem.value = null
  openTags.value = false
}
// 标签总条数
const tagsTotal = ref(0)
// 标签当前页
const tagsPage = ref(1)
// 处理标签翻页
const handleChangeTagsPage = () => {
  handleGetTagsList()
}

/*删除操作对话框*/
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await storeDelete(item.storeId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}

// 编辑扩展信息
const setExInfo = (info) => {
  router.push({path: "/editPostExInfo", query: {storeId: info.storeId}})
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addPost")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('any', 'store:add')">新建门店</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.name"
                        placeholder="请输入门店名"
                        label="门店名"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'store:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'store:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.name="{ item }">
            <div class="txt_overflow" :title="item.name">{{item.name}}</div>
          </template>

          <template v-slot:item.storeType="{ item }">
            <div class="txt_overflow" v-if="item.storeType === 'STATION'" :title="'驿站'">驿站</div>
<!--            <div class="txt_overflow" v-else-if="item.storeType === 'TENNIS_VENUE'" :title="'网球场馆'">网球场馆</div>-->
            <div class="txt_overflow" v-else-if="item.storeType === 'PUMP_TRACK_VENUE'" :title="'泵道场地'">泵道场地</div>
            <div class="txt_overflow" v-else-if="item.storeType === 'MOUNTAIN_BIKE_VENUE'" :title="'山地场地'">山地场地</div>
            <div class="txt_overflow" v-else-if="item.storeType === 'BMX_VENUE'" :title="'小轮车场地'">小轮车场地</div>
            <div class="txt_overflow" v-else-if="item.storeType === 'BIKE_STORE'" :title="'单车4S店'">单车4S店</div>
          </template>

          <template v-slot:item.showAddress="{ item }">
            <div class="txt_overflow" :title="item.showAddress">{{item.showAddress}}</div>
          </template>

          <template v-slot:item.tagList="{ item }">
            <div>
              <YTTagGroup :list="item.tagList.map(res => res.tagName)"></YTTagGroup>
            </div>
          </template>

          <template v-slot:item.isSelfOperated="{ item }">
            <div>
                <!-- 管理员不勾选，表示这个门店是骑么自营门店；
                管理员勾选，但是没有填写“合作门店小程序链接”，表示这个门店是合作门店，但是使用biking up小程序点餐；
                管理员勾选，并填写“合作门店小程序链接”，表示这个门店是合作门店，并且跳转到他们自有小程序进行点餐；-->
              {{ item.isSelfOperated ? '否' : '是' }}
            </div>
          </template>

          <template v-slot:item.operatingHoursChineseAndEnglish="{ item }">
            <div>
              <div class="txt_overflow" v-for="items in item.operatingHoursChineseAndEnglish" :title="`${items.weekdayOpen}至${items.weekdayClose} ${items.operatingStart} - ${items.operatingEnd}`">
                {{items.weekdayOpen}}至{{items.weekdayClose}} {{items.operatingStart}} - {{items.operatingEnd}}
              </div>
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="setTop(item, true)" :title="`置顶“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="!item.isTop"
                        class="box-item"
                        effect="dark"
                        content="置顶"
                        placement="left">
                      <v-icon class="cursor-pointer mg_r_1" icon="mdi-arrow-collapse-up" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setTop(item, false)" :title="`取消置顶“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.isTop"
                        class="box-item"
                        effect="dark"
                        content="取消置顶"
                        placement="left">
                      <v-icon class="cursor-pointer mg_r_1" icon="mdi-arrow-collapse-down" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="$handleHasBtnPermission('all', 'store:edit')"></v-icon>
              </el-tooltip>
<!--              <el-tooltip-->
<!--                  class="box-item"-->
<!--                  effect="dark"-->
<!--                  content="扩展信息"-->
<!--                  placement="top">-->
<!--                <v-icon class="mg_l_1" icon="mdi-store-edit-outline" color="warning" size="small" @click="setExInfo(item)"></v-icon>-->
<!--              </el-tooltip>-->
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="标签"
                  placement="top">
                <v-icon class="mg_l_1" icon="mdi-tag-outline" color="success" @click="setTags(item)"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除门店 “${item.name}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'store:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>

  <YTCheckPanel
      v-if="openTags"
      :open="openTags"
      :title="`${cacheItem.name} - 标签`"
      :checkedList="cacheItem.tagList.map(res => res.tagId)"
      :list="listTags"
      :hasAll="false"
      :checkedLimit="2"
      @cancel="handlePanelTagsClose"
      @confirm="handlePanelTagsConfirm"
      :maxWidth="600"
  >
    <template v-slot:pagination>
      <div class="flex_right text-right pt-2" style="width: 100%;">
        <v-pagination
            v-model="tagsPage"
            :length="Math.ceil(tagsTotal / 10)"
            :total-visible="6"
            @update:modelValue="handleChangeTagsPage"
            v-if="tagsTotal > 0"
        ></v-pagination>
      </div>
    </template>
  </YTCheckPanel>
</template>

<style scoped>

</style>
